import type { RoleConfig } from '../types.js';

export const plaguebearer: RoleConfig = {
  id: 'plaguebearer',
  faction: 'solo',
  title: { ru: 'Чумной', uk: 'Чумний' },
  latin: 'PLAGUEBEARER',
  number: '52',
  accent: '#5ad6a8',
  sub: '#185040',
  ability: {
    ru: 'Заражает игрока — следующей ночью он молчит и сам становится переносчиком: каждый, кто посетит заражённого, заразится. Побеждает, когда живут только заражённые.',
    uk: 'Заражає гравця — наступної ночі він мовчить і сам стає переносником: кожен, хто відвідає заражeного, заразиться. Перемагає, коли живими лишилися тільки заражeні.',
  },
  abilities: [
    { key: 'plague', phase: 'night', cadence: 'every-night', canSelfTarget: false },
  ],
  victory: { type: 'solo-all-infected' },
};
